module.exports = __webpack_public_path__ + "img/hide-typing-recording-status.68dd54b3.webp";